<template>
  <v-layout>
    <v-card color="primary" dark width="100%">
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text class="headline white--text">${{ total | thousandSeprator }}</v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  props: {
    total: Number,
    title: String,
    subtitle: String
  }
};
</script>



// WEBPACK FOOTER //
// TotalNumber.vue?fb3b0780